import React, { FC } from "react";
import { observer } from 'mobx-react-lite';
import { InstructionNodeProps } from '../InstructionNodeFactory';
import { SettingNode } from './SettingNode';
import { PneumaticNode } from './PneumaticNode';
import { CombinedNode } from './CombinedNode';
import { ActuatorNode } from './ActuatorNode';
import { MotorInstruction } from '../../../../../../machinelogic/types';


interface MotorNodeProps extends InstructionNodeProps {
  instruction: MotorInstruction
}

export const MotorNodeFactory: FC<MotorNodeProps> = observer((props) => {

  switch (props.instruction.name) {
    case 'setAcceleration':
    case 'setSpeed':
    case 'setActuatorSpeed':
    case 'setActuatorAcceleration':
      return <SettingNode {...props} instruction={props.instruction} />;

    case 'push':
    case 'pull':
    case 'idle':
    case 'open':
    case 'close':
      return <PneumaticNode {...props} instruction={props.instruction} />;

    case 'moveRelativeCombined':
    case 'moveAbsoluteCombined':
      return <CombinedNode {...props} instruction={props.instruction} />;

    case 'home':
    case 'moveAbsolute':
    case 'moveRelative':
    case 'moveToClosestAngle':
    case 'defineAngle':
    case 'stopActuatorMotion':
    case 'stopAllMotion':
    case 'setContinuousMove':
    case 'stopContinuousMove':
    case 'moveVFD':
    case 'stopVFD':
      return <ActuatorNode {...props} instruction={props.instruction} />;
  }
});
